// EditHotelForm.js
import React, { useState } from "react";
import axios from "axios";
import "../css/AddHotel.css";

const EditHotelForm = ({ hotel, onClose, onUpdated }) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    global_hotel_name: hotel.global_hotel_name || "",
    global_address: hotel.global_address || "",
    managed_by: hotel.managed_by || "",
    contact_person_name: hotel.contact_person_name || "",
    contact_email: hotel.contact_email || "",
    contact_phone: hotel.contact_phone || "",
    website_url: hotel.website_url || "",
    description: hotel.description || "",
  });

  const [file, setFile] = useState(null);

  // ✅ EXISTING IMAGE FROM DB (photo_url)
  const existingImage =
    hotel.photo_url && hotel.photo_url !== ""
      ? `${API_URL}/ems${hotel.photo_url}`
      : null;

  // ✅ SHOW NEW IMAGE PREVIEW IF SELECTED
  const previewImage = file
    ? URL.createObjectURL(file)
    : existingImage;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const fd = new FormData();

      Object.keys(formData).forEach((key) => {
        fd.append(key, formData[key]);
      });

      if (file) {
        fd.append("photo", file); // 👈 must match backend multer field
      }

      await axios.put(
        `${API_URL}/ems/global-hotels/${hotel._id}`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert("Hotel updated successfully!");
      onUpdated?.();
      onClose();
    } catch (error) {
      console.error("Edit hotel error:", error);
      alert(error.response?.data?.message || "Failed to update hotel");
    }
  };

  return (
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog modal-md add-hotel-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Hotel</h5>
          </div>

          <div className="modal-body add-hotel">
            

            <div className="mb-3">
              <label className="form-label">Hotel Name <span className="text-danger">*</span></label>
              <input
                type="text"
                name="global_hotel_name"
                className="form-control"
                placeholder="Enter hotel name"
                value={formData.global_hotel_name}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Address <span className="text-danger">*</span></label>
              <input
                type="text"
                name="global_address"
                className="form-control"
                placeholder="Enter address"
                value={formData.global_address}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Managed By</label>
              <select name="managed_by" className={"form-control" + (formData.managed_by ? "" : " select-placeholder")} value={formData.managed_by} onChange={handleChange}>
                <option value="">Select...</option>
                <option value="IGF">IGF</option>
                <option value="LOCOG">LOCOG</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Contact Person Name <span className="text-danger">*</span></label>
              <input
                type="text"
                name="contact_person_name"
                className="form-control"
                placeholder="Enter contact person name"
                value={formData.contact_person_name}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Contact Email <span className="text-danger">*</span></label>
              <input
                type="email"
                name="contact_email"
                className="form-control"
                placeholder="e.g. contact@hotel.com"
                value={formData.contact_email}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Contact Phone <span className="text-danger">*</span></label>
              <input
                type="text"
                name="contact_phone"
                className="form-control"
                placeholder="e.g. +1 234 567 8900"
                value={formData.contact_phone}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Website URL</label>
              <input
                type="text"
                name="website_url"
                className="form-control"
                placeholder="e.g. https://www.hotel.com"
                value={formData.website_url}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                name="description"
                className="form-control"
                placeholder="e.g. Brief description of the hotel"
                value={formData.description}
                onChange={handleChange}
              />
            </div>
            {previewImage && (
              <div className="mb-3 text-center">
                <label className="form-label">Hotel Image</label>
                <img
                  src={previewImage}
                  alt="Hotel"
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                />
              </div>
            )}
            <div className="mb-3">
              <label className="form-label">Update Image</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={handleFileChange}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              onClick={handleSubmit}
              className="btn"
              style={{ background: "#D9A128", color: "#fff" }}
            >
              Update
            </button>
            <button
              onClick={onClose}
              className="btn"
              style={{ background: "#000", color: "#fff" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditHotelForm;
